import React from 'react';
import PropTypes from 'prop-types';
import { TimeWithTimeZone, Icon } from '@common/components';
import { StateBadge } from 'works/components/state-badge';
import { Col, Row } from 'antd';

import {
  COLOR_STYLE_MAP,
  LABEL_OVERWRITE,
} from 'works/components/staffing-request-state';

export function StaffingRequestStateBadge({
  state,
  timestamp,
  submissionsPaused,
  showPausedSubmissionLabel,
}) {
  const isNewSubmissionsPaused = submissionsPaused && state === 'OPEN';

  const statusIcons = (
    <>
      {isNewSubmissionsPaused && (
        <Icon
          icon="doNotEnter"
          color="rubyRed"
          size="sm"
          tooltipText="Not accepting new submissions"
        />
      )}
    </>
  );

  return (
    <Row style={{ display: 'flex', flexWrap: 'nowrap' }}>
      <Col>
        <StateBadge
          state={LABEL_OVERWRITE[state] || state}
          caption={
            timestamp ? (
              <TimeWithTimeZone date={timestamp} variant="long_format" />
            ) : null
          }
          color={COLOR_STYLE_MAP[state]}
          statusIcons={statusIcons}
          statusLabel={
            showPausedSubmissionLabel &&
            isNewSubmissionsPaused &&
            'Not accepting submissions'
          }
        />
      </Col>
    </Row>
  );
}

StaffingRequestStateBadge.propTypes = {
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  timestamp: PropTypes.string,
  submissionsPaused: PropTypes.bool,
  showPausedSubmissionLabel: PropTypes.bool,
};
